<template>
  <q-layout view="lhh LpR lff">
    <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
    <q-page-container>
      <q-page padding ref="qPage">
        <div class="row justify-between">
          <q-btn class="justify-center q-ma-xs q-pr-md" ripple dense flat color="black" to="/statistics">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
        </div>
        <q-card class="row q-my-xs">
          <div class="col-12 q-pa-md">
            <div class="text-h5 text-center q-py-md">Báo cáo ngày</div>
          </div>
          <div class="col-xs-12 col-sm-4 q-pa-md">
            <div class="row justify-between">
              <q-input class="col" flat readonly v-model="filterDate">
                <template v-slot:append>
                </template>
              </q-input>
              <q-icon name="event" class="cursor-pointer col-1 self-center" size="32px">
                <q-popup-proxy d ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date flat v-model="filterDate" mask="DD/MM/YYYY" minimal @input="() => $refs.qDateProxy.hide()" />
                </q-popup-proxy>
              </q-icon>
              <q-btn style="height: 25%" icon="cloud_download" flat color="black" size="20px" @click="download" class="q-mx-md col-2 cursor-pointer" :disable="disableBtn" :loading="isFetching"/>
            </div>
          </div>
        </q-card>

        <div v-for="(item, key) in tables" :key="key">
          <q-table
            :title="item.title"
            :data="item.data"
            :columns="headers"
            :style="item.style"
            row-key="fieldName"
            no-data-label="Không có dữ liệu"
            :pagination.sync="pagination"
            :loading="isFetching"
            class="q-mb-md"
            :hide-bottom="!_.isEmpty(item.data)"
            >
          </q-table>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>
<script>
import moment from 'moment'
import { firebase } from '@firebase/app'
const { Timestamp } = firebase.firestore
const XlsxPopulate = require('xlsx-populate')
import { mapGetters } from 'vuex'
export default {
  name: 'DailyStatistics',
  data() {
    return {
      tables: {
        sum: {
          title: 'Tổng',
          style:'display:none',
          farm:0,
          data: []
        }
      },
      filterDate: moment.utc().format('DD/MM/YYYY'),
      headers: [
        {
          name: 'no',
          required: true,
          label: 'No',
          align: 'left',
          format: (val, row) => `${row.__index + 1}`,
          sortable: true
        },
        {
          name: 'job',
          required: true,
          label: 'Công việc',
          align: 'center',
          field: row => row.job,
          format: val => `${val}`,
          sortable: true
        },
        {
          name: 'weight',
          required: true,
          label: 'Khối lượng',
          align: 'center',
          field: row => row.weight,
          format: val => `${val > 0 ? val.toFixed(2) : val}`,
          sortable: true
        },
        {
          name: 'unit',
          required: true,
          label: 'Đơn vị',
          align: 'center',
          field: row => row.unit,
          format: val => `${val}`,
          sortable: true
        },
        {
          name: 'labor',
          required: true,
          label: 'Nhân công',
          align: 'center',
          field: row => row.labor,
          format: val => `${val}`,
          sortable: true
        },
        {
          name: 'timeWorker',
          required: true,
          label: 'Công nhật',
          align: 'center',
          field: row => row.timeWorker,
          format: val => `${val}`,
          sortable: true
        },
        {
          name: 'piecework',
          required: true,
          label: 'Công khoán',
          align: 'center',
          field: row => row.piecework,
          format: val => `${val}`,
          sortable: true
        }
      ],
      pagination: {
        rowsPerPage: 20,
      },
      disableBtn: false,
      isFetching: false,
      dataFetched: [],
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapGetters([
      'jobStore',
      'farmStore',
      'permission'
    ])
  },
  methods: {
    async fetchData() {
      let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
      let vm = this
      let roles = this._.intersection(accept, Object.keys(this.permission.roles))
      if (roles.length > 0) {
        vm.isFetching = true
        await vm.$query(['Reports'], [['date', '==', Timestamp.fromDate(moment.utc(vm.filterDate, 'DD/MM/YYYY').toDate())], ['deleted', '==', false]])
          .then((res) => {
            vm.dataFetched = res.data
            vm.processData(vm.dataFetched)
          }).catch(error => {
            vm.$q.notify({
              message: error.toString(),
              color: 'red',
              icon: 'error'
            })
          })
        vm.isFetching = false
      } else {
        vm.disableBtn = true
        vm.$q.notify({
          message: 'You don\'t have permission',
          color: 'red',
          icon: 'error'
        })
      }
    },
    processData(resData) {
      let vm = this
      let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
      let roles = this._.intersection(accept, Object.keys(this.permission.roles))
      for (let i in vm.farmStore.list)
      {
        vm.tables['id'+i] = {
          title: vm.farmStore.list[i].name,
          farmName: vm.farmStore.list[i].name,
          farm: vm.farmStore.list[i].id,
          data: [],
          style: 'display:none',
        }
      }
      if (roles.indexOf('BOM') > -1) {
        for (let i in vm.tables) {
          vm.tables[i].style = 'display:block'
          vm.tables[i].data = this.transformData(vm._.cloneDeep(resData), vm.tables[i].farm)
        }
      }
      else {
        roles.forEach(r => {
          let numberPattern = /\d+/g
          let farm = r.match(numberPattern)
          vm.tables[`id${farm-1}`].style = 'display:block'
          vm.tables[`id${farm-1}`].data = this.transformData(vm._.cloneDeep(resData), vm.tables[`id${farm-1}`].farm)
        })
      }
    },
    download() {
      let vm = this
      let csvFields = [['STT','Công việc', 'Khối lượng', 'Đơn vị', 'Nhân công','Công nhật', 'Công khoán']]
      let colWidth = [
        {col: 'A', wpx:10}, //stt
        {col: 'B',wpx:30},//cv
        {col: 'C',wpx:20}, //kl
        {col: 'D',wpx:20}, //dv
        {col: 'E',wpx:20},// nc
        {col: 'F',wpx:20},//cn
        {col: 'G',wpx:20},//ck
      ]
      ///XlsxPopulate
      XlsxPopulate.fromBlankAsync().then(workbook => {
        vm._.forEach(vm.tables, table => {
          let sheetData = vm._.cloneDeep(csvFields)
          if (table.style !== 'display:none')
          {
            for (let i in table.data) {
              let row = [i]
              row.push(table.data[i].job)
              row.push(table.data[i].weight)
              row.push(table.data[i].unit)
              row.push(table.data[i].labor)
              row.push(table.data[i].timeWorker)
              row.push(table.data[i].piecework)
              sheetData.push(row)
            }
            
            if (workbook.sheet(0).name() !== "Sheet1") {
              workbook.addSheet(table.title)
            }
            let wsLength = workbook.sheets().length-1
              workbook.sheet(wsLength).name(table.title).row(1).style("bold", true)
              workbook.sheet(wsLength).cell("A1").value(sheetData)
              for (let j in colWidth) {
                workbook.sheet(wsLength).column(colWidth[j].col).width(colWidth[j].wpx)
            }
          }
        })
        return workbook.outputAsync()
        }).then(blob => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, 'Bao-cao-ngay-'+moment.utc(this.filterDate,'DD/MM/YYYY').format('DD-MM-YYYY') + '.xlsx')
          }
          else {
            var url = window.URL.createObjectURL(blob)
            var a = document.createElement("a")
            document.body.appendChild(a)
            a.href = url
            a.download = 'Bao-cao-ngay-'+moment.utc(this.filterDate,'DD/MM/YYYY').format('DD-MM-YYYY')
            a.click()
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
          }
        }).catch(err => {
          throw err
        })
    },
    transformData (resData, farm) {
      let result = []
      let data = this._.groupBy(farm > 0 ? resData.filter(item => item.farm === farm) : resData, 'job')
      for(let key in data) {
        let jobMaster = this._.find(this.jobStore.list, o => o.id === key)
        result.push({
          job: jobMaster.name ? jobMaster.name : '',
          unit: jobMaster.unit ? jobMaster.unit : '',
          weight: this._.sumBy(data[key], 'totalWeight'),
          labor: this._.sumBy(data[key], (o) => o.worker.number),
          timeWorker: this._.sumBy(data[key].filter(item => item.worker.type === 'congnhat'), (o) => o.worker.number),
          piecework: this._.sumBy(data[key].filter(item => item.worker.type === 'khoan'), (o) => o.worker.number)
        })
      }
      return result ? result.sort((a,b) => a.job.localeCompare(b.job)) : []
    }
  },
  watch: {
    filterDate() {
      this.fetchData()
    }
  },
}
</script>
